import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import { DateTool} from "mgToolsKit";
import { ProgressBar } from "../../../Common/ui";
import { MGSiteButton } from 'mgUiKit';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetFunbonusComponent';

class Funbonus extends React.Component {
    constructor(props) {
        super(props);
        this.goToPage = this.goToPage.bind(this);
    }    
      
    renderInfoAggiuntive(){
        var funbonus = this.props.data;
        var id  = "info-dettagli-" + funbonus.Code;
        return (
            <div className="mg-dati-coupon-moreinfo">
                <input type="checkbox" id={id} className="toggle-info" />
                <label htmlFor={id} className="toggle-label">Informazioni e dettagli</label>
                <div className="mg-dati-coupon-moreinfo-opened">
                   
                    <p className="mg-long-description">{funbonus.LongDescription}</p>
                    
                </div>
            </div>
        );
    }

    goToPage(){
              
        if(AppSettings.funbonusurl != ""){
            var urlfunbonus = AppSettings.funbonusurl;
            location.href = urlfunbonus;
        };  
        
    }

    truncateDecimal(number, decimals) {

        if (isNaN(number) || number.toString().indexOf("-") != -1)
            number = 0;
        var stringOfnumber = parseFloat(number);
        return stringOfnumber.toFixed(decimals + 1).split(".")[0] + "." + stringOfnumber.toFixed(3).split(".")[1].substr(0, decimals);
    
    }

    renderProgressBar(){

        var funbonus = this.props.data;
        var _percent = (funbonus.Percent > 100) ? 100 : Math.trunc(funbonus.Percent); 
        
        return (
            <ProgressBar percentage={_percent} />
        );
    }

    renderScadenza(){
        var funbonus = this.props.data;
        
        var expire = parseInt(funbonus.ValidTo.replace(/(^.*\()|([+-].*$)/g, ''));
        if(isNaN(expire) || expire <=0){
            return "";
        }        
        var date = new DateTool(expire);
        var expireString = "al " + date.getDate()
        if(date.isToday()){
            expireString = "a oggi";
        }
        if(date.isTomorrow()){
            expireString = "a domani";
        }
        return (
            <span className="mg-bonus-data">Valido fino <strong>{expireString}</strong></span>
        )        
        
    }

    render() {

        var State = {    
            "1": "Attivo",            
            "2": "Attivo",            
            "5": "In corso"
        };

        var Type = {    
            "1": "Fisso",            
            "2": "Limit",
            "3": "No Limit"                
        };


        var formatEuro = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
        });
        var funbonus = this.props.data;

        var _couponValue ="";
        var _product = funbonus.CouponDescription.toLowerCase().replace("coupon ", "");
        var _productClass = "promotionslist-info--coupon coupon-" + funbonus.CouponCode.toLowerCase();       

        if(funbonus.ReleaseType == "1")
            _couponValue = "COUPON " + _product + " Fun bonus inziale";
        else if(funbonus.ReleaseType == "2")
            _couponValue = "COUPON " + _product + " Limit " + funbonus.MaxAmount.toFixed(2).replace('.', ',') + " €";
        else if(funbonus.ReleaseType == "3")
            _couponValue = "COUPON " + _product + " No Limit ";

        var baseCssClass = "mg-user-widget";
        var cssClass = baseCssClass + " mg-bonus-funbonus";

        if(funbonus.State == 5)
            cssClass += " funbonus-incorso";       
        
        
        var urlfunbonus = AppSettings.funbonusurl;
        let fbImg = funbonus.ImageUrl != null && funbonus.ImageUrl != "";
        let imgStyle = {};
        let playBtn = false;
        if(fbImg && funbonus.State == 5){
            playBtn = true;
            imgStyle = {
                "padding-bottom": "15px"
            }
        }
        
        return (
            <div className={cssClass}>                
                <div className="mg-dati-ecoupon" onClick={this.goToPage}>
                    <i className="mg-icon-funbonus"></i>
                    <div className="mg-bonus-wrap">
                    <a className="mg-play-game" href={urlfunbonus}>
                        <span className="mg-user-widget-titolo">
                        {funbonus.Description}
                        </span>
                    </a>
                    {(funbonus.State == 5) ? 
                        <span className="mg-bonus-data">
                            {this.renderProgressBar()}
                        </span>
                    : ""}
                        <span className="mg-bonus-data">Stato <strong>{State[funbonus.State]}</strong></span>
                        {this.renderScadenza()}                        
                    </div>
                    <span className="mg-bonus-importo--valore">
                        {formatEuro.format(funbonus.AvailableBalance)}
                    </span>
                </div>
                { fbImg ?
                    <img style={imgStyle} alt="Immagine coupon" className="mg-image-promotion" src={funbonus.ImageUrl} />
                : ""}                
                { playBtn ? 
                <MGSiteButton
                    title="Gioca ora"
                    class="mg-link-promotion"
                    label="Gioca ora"
                    disabled={false}
                    primary={true}
                    isButton={true}
                    fullWidth={true}
                    actionFunc={this.goToPage}
                /> : ""}
            </div>
        );
    }
}

Funbonus.displayName = componentName;

// PropTypes validation
Funbonus.propTypes = {
    data: PropTypes.object.isRequired
};

// default props
Funbonus.defaultProps = {
};

export default Funbonus;